<!-- リンクボタン -->
<template>
  <div class="home_cat_buttons1">
    <div
      v-for="button in iconMenuPreviewDataList"
      :key="button.menuId"
      :class="['button1', { hover: button.hover }]"
      @mouseover="button.hover = true"
      @mouseleave="button.hover = false"
    >
      <span
        :class="['image1', button.hover ? 'hover' : '']"
        :style="{
          backgroundImage: `url(/WITH_AG_PORTAL/images/${
            button.hover ? button.imageFileOver : button.imageFileNomal
          })`,
          backgroundColor: '#F3F5F9', // 背景色
          backgroundPosition: 'center', // 画像を中央に配置
          backgroundSize: 'cover', // 画像をカバーとして設定
          transition: '0.5s ease',
          transform: button.hover ? 'scale(1.05)' : 'scale(1)', // ホバー時にスケールを変更
        }"
      ></span>
      <span class="text1">{{ button.menuName }}</span>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";

interface Item {
  menuId: string;
  menuName: string;
  imageFileNomal: string;
  imageFileOver: string;
  linkURL: string;
  hover: boolean;
}

export default defineComponent({
  name: "IconMenuComponent",
  props: {
    previewData: {
      type: Array as () => Item[],
      required: true,
    },
  },
  setup(props) {
    const isHover = ref(false);
    const iconMenuPreviewDataList = computed(() => props.previewData);
    return {
      isHover,
      iconMenuPreviewDataList,
    };
  },
});
</script>
